export const modalTypes = {
  ACCESS_POLICY_MODAL: 'accessPolicyModal',
  AMENITIES_MODAL: 'amenitiesModal',
  BEFORE_YOU_GO_CONFIRMATION_MODAL: 'beforeYouGoConfirmationModal',
  GUEST_POLICY_MODAL: 'guestPolicyModal',
  LOCATION_MAP_MODAL: 'locationMapModal',
  SELECT_CARD_MODAL: 'selectCardModal',
  TERMS_MODAL: 'termsModal',
  CULINARY_COLLECTIVE_PAGE_MODAL: 'culinaryCollectivePageModal',
};
